import React from "react";
import { HeroSection } from "./heroSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { useSiteMetadata } from "../hooks/site-meta";

const HeadingText = (props) => {
  const { author } = useSiteMetadata();
  let className = "text-center pt-28 pb-16 max-w-2xl mx-auto px-3 lg:px-0 ";
  let isArticle = null;
  if (props.headingClass) {
    className += props.headingClass;
  }
  if (props.author || props.readTime) {
    isArticle = true;
  }
  const theAuthor = props.author?.name || author;

  console.log(props);

  const ArticleMeta = (props) => {
    return (
      <div
        className={`article-meta pt-2 grid grid-cols-1 lg:grid-cols-2 gap-2 px-5 lg:px-0`}
      >
        {theAuthor && (
          <div className="lg:text-left">
            {props.dates && (
              <>
                Posted{" "}
                <time dateTime={props.dates.dateTime}>{props.dates.date}</time>{" "}
                by{" "}
              </>
            )}
            <span className="font-bold">{theAuthor}</span>

            {props.modified && (
              <>
                <br />
                Last updated{" "}
                <time dateTime={props.modified.dateTime}>
                  {props.modified.date}
                </time>
              </>
            )}
            {props.featuring && (
              <>
                <br />
                <>Featuring </>
                {props.featuring.map((feature, index) => {
                  return (
                    <span key={`feature-${index}`} className="font-bold">
                      {index > 0 && ", "}{" "}
                      {feature.url ? (
                        <a
                          href={feature.url}
                          target="_blank"
                          className="underline"
                          rel="noreferrer"
                        >
                          {feature.name}
                        </a>
                      ) : (
                        <>{feature.name}</>
                      )}
                    </span>
                  );
                })}
              </>
            )}
          </div>
        )}
        {props.readTime && (
          <div className="lg:text-right">
            <FontAwesomeIcon icon={faStopwatch} className="mr-2" />
            <span title="estimated reading time">
              {props.readTime} min
            </span>{" "}
            read
          </div>
        )}
      </div>
    );
  };
  return (
    <div className={className}>
      <h1 className="text-4xl font-extrabold font-semi-expanded mb-2">
        {props.title}
      </h1>
      {props.subtitle && (
        <p className="text-3xl max-w-lg mx-auto font-semi-condensed">
          {props.subtitle}
        </p>
      )}
      {isArticle && <ArticleMeta {...props} />}
    </div>
  );
};

export const LandingTitle = (props) => {
  const hProps = {};
  hProps.gradientClass = props.gradientClass;
  hProps.parentClass = props.parentClass;
  if (props.image || props.background) {
    hProps.image = props.image || props.background;
  }
  if (props.style) {
    hProps.style = props.style;
  }
  if (props.contentClass) {
    hProps.contentClass = props.contentClass;
  }
  if (props.imageClass) {
    hProps.className = props.imageClass;
  }
  if (props.imageStyle) {
    hProps.imageStyle = props.imageStyle;
  }
  const articleProps = {};
  if (props.author) {
    articleProps.author = props.author;
  }
  if (props.featuring) {
    articleProps.featuring = props.featuring;
  }
  if (props.readTime) {
    articleProps.readTime = props.readTime;
  }
  if (props.dates) {
    articleProps.dates = props.dates;
  }
  if (props.modified) {
    articleProps.modified = props.modified;
  }

  if (props.image) {
    return (
      <HeroSection {...hProps}>
        <HeadingText
          title={props.title}
          subtitle={props.subtitle}
          headingClass={props.headingClass}
          {...articleProps}
        />
      </HeroSection>
    );
  }
  return (
    <HeadingText
      title={props.title}
      subtitle={props.subtitle}
      headingClass={props.headingClass}
      {...articleProps}
    />
  );
};

LandingTitle.defaultProps = {
  title: "",
  subtitle: "",
  backgroundFile: "",
  gradientClass: "bg-gradient-to-r from-purple-900/90 to-rose-900/75 py-10 ",
  parentClass: "text-center text-white",
  contentClass: "",
  headingClass: "",
};
